module.exports = __webpack_public_path__ + "icon_arrow_gray.9ecbf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/icon_arrow_gray.svg
// module id = ./src/_asset/sources/assets/images/@svg/icon_arrow_gray.svg
// module chunks = main